import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/tables/table";
import { useEffect, useState } from "react";
import { getCategoryReducerForActive } from "../../store/categoryReducers";
import { getActiveWarehouseReducer } from "../../store/warehouseReducer";
import {
  getAllTransactionReducer,
} from "../../store/transactionReducers";
// import { ConvertDate } from "../../utils/moment";
import { ConvertDate } from "../../utils/moment";
import TransactionFilter from "../../components/TransactionFilter";

const ProductReport = () => {
  const dispatch = useDispatch();
  const { transactions } = useSelector((state) => state.transaction);
  const { categories } = useSelector((state) => state.category);
  const { warehouses } = useSelector((state) => state.warehouse);
 
  
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({
    warehouseId: null,
    categoryId: null,
    transactionType: null,
    specificDate: null,
    dateRange: null,
    grnSearchQuery: '',
    ginSearchQuery: '',
    customerSearchQuery: '',
    productSearchQuery: '',
  });

  useEffect(() => {
    dispatch(getActiveWarehouseReducer());
    dispatch(getCategoryReducerForActive());

    
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllTransactionReducer({...filters,page:currentPage,limit:pageSize}));
  }, [dispatch, filters,currentPage,pageSize]);

  
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size); // Update page size
    setCurrentPage(1); // Reset to first page when page size changes
  };
  

  

  const handleFilterChange = (newFilters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  const handleReset = () => {
    setFilters({});
  };

  const columns = [
    
    {
      title: "Product",
      width:'25%',
      render: (text, record) => <div>
        <p style={{textTransform:"capitalize",fontWeight:"bolder",color:"#000"}}>{record.inventory?.product?.name}</p>
        <p style={{textTransform:"capitalize"}}>{record.inventory?.product?.code}</p>
        <p>{record?.inventory?.product?.category?.name}</p>
      </div>,
    },
    {
      title: "Transaction Details",
      width:'25%',
      render: (text, record) => (
        <div style={{textTransform:"capitalize"}}>
          <p>{ConvertDate(record?.transaction_date)}</p>
          <p>by: <span style={{textTransform:"capitalize",color:"#000"}}>{record?.user?.first_name + " " + record?.user?.last_name}</span></p>
          {record?.customer?.name && <p>to: <span style={{textTransform:"capitalize",color:"#000"}}>{record?.customer?.name} ({record?.customer?.phone_no})</span></p>}
          <p>Warehouse: <span style={{textTransform:"capitalize",color:"#000"}}>{record?.inventory?.warehouse?.name}</span></p>
        </div>
      ),
    },
    {
      title: "Transaction Type",
      render: (text, record) => <span>{record.transaction_type}</span>,
    },
    {
      title: "Ref",
      render: (text, record) => <span>
        {record?.grn && <p>GRN: {record?.grn}</p>}
        {record?.gin && <p>GIN: {record?.gin}</p>}
      </span>,
    },
    // {
    //   title: "Taken By",
    //   render: (text, record) => <span>{record.taken_by ? record.taken_by : "Empty"}</span>,
    // },
    
    {
      title: "Quantity",
      width: "20%",
      render: (text, record) => (
        <>
          {record.quantity?.map((item) => (
            <div className="flex flex-row">
              <span className="font-bold">{item.value}</span> {" "}
              <span className="mr-2 capitalize" style={{textTransform:"capitalize"}}>{item.name} </span>
              
            </div>
          ))}
        </>
      ),
    },
  ];

  return (
    <div>
      <p className="text-xl pt-2 pb-2"> Transaction Range</p>
      <TransactionFilter
        onFilterChange={handleFilterChange}
        warehouses={warehouses}
        categories={categories}
        types={["Incoming", "Outgoing"]}
        grnSearchQuery={filters.grnSearchQuery}
        ginSearchQuery={filters.ginSearchQuery}
        customerSearchQuery={filters.customerSearchQuery}
        productSearchQuery={filters.productSearchQuery}
        selectedWarehouse={filters.warehouseId}
        selectedCategory={filters.categoryId}
        selectedType={filters.transactionType}
        selectedDateRange={filters.dateRange}
        onReset={handleReset}
      />
      <CustomTable columnnn={columns} dataaa={transactions.transactionsList} 
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: transactions?.total_count,
        onChange: handlePageChange,
      }}
      onPageSizeChange={handlePageSizeChange}

      />
    </div>
  );
};
export default ProductReport;
